import React from 'react';
import { useSelector } from 'react-redux';
import { Route, Routes, NavLink, Navigate, Link } from 'react-router-dom';
import Orders from './Orders';
import Reviews from './Reviews';
import Following from './Following';
import Edit from './Edit';
import BpChat from '../BpChat';
import { IMAGE_URL } from '../../Constants/constants';

const TABS = [
	{ to: 'pre-orders', label: 'Orders', icon: 'fa-cube' },
	{ to: 'inbox', label: 'Messages', icon: 'fa-comments-o' },
	{ to: 'reviews', label: 'Reviews', icon: 'fa-star-o' },
	{ to: 'following', label: 'Following', icon: 'fa-heart-o' },
	{ to: 'edit', label: 'Settings', icon: 'fa-cog' },
];

export default function Profile() {
	const user = useSelector(state => state.user);
	const wallet = user.walletAddress;

	return (
		<div className="bp-profile-page">
			<div className="bp-profile-hero">
				<div className="bp-profile-id">
					<div className="bp-profile-avatar">
						{user.image
							? <img src={IMAGE_URL + user.image} alt="" />
							: <span>{(user.username || 'U').charAt(0).toUpperCase()}</span>}
					</div>
					<div className="bp-profile-meta">
						<h2>{user.username || 'Your Account'}</h2>
						<div className="bp-profile-chips">
							<span className={`bp-profile-role ${user.role === 'SELLER' ? 'seller' : ''}`}>
								{user.role === 'SELLER' ? '🏬 Seller' : '🛍️ Shopper'}
							</span>
							{wallet && (
								<span className="bp-profile-wallet bp-mono" title={wallet}>
									<em className="jp-live-dot" /> {wallet.slice(0, 6)}…{wallet.slice(-4)}
								</span>
							)}
							{user.email && <span className="bp-profile-mail">{user.email}</span>}
						</div>
					</div>
				</div>
				<div className="bp-profile-actions">
					{user.role === 'SELLER' && (
						<Link to="/dashboard" className="bp-btn-primary">Seller Dashboard</Link>
					)}
					<Link to="/search" className="bp-btn-ghost">Browse Shops</Link>
				</div>
			</div>

			<nav className="bp-profile-tabs" aria-label="Profile sections">
				{TABS.map(t => (
					<NavLink
						key={t.to}
						to={t.to}
						className={({ isActive }) => `bp-profile-tab ${isActive ? 'active' : ''}`}>
						<i className={`fa ${t.icon}`} /> {t.label}
					</NavLink>
				))}
			</nav>

			<div className="bp-profile-body">
				<Routes>
					<Route path="pre-orders/*" element={<Orders />} />
					<Route path="inbox" element={<div className="bp-chat-page"><BpChat inline /></div>} />
					<Route path="reviews/*" element={<Reviews />} />
					<Route path="following" element={<Following />} />
					<Route path="edit" element={<Edit user={user} />} />
					<Route path="*" element={<Navigate to="pre-orders" replace />} />
				</Routes>
			</div>
		</div>
	);
}
